<template>
  <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
    <figure
      v-for="item in items"
      :key="item.id"
      class="group relative flex flex-col overflow-hidden rounded-2xl border border-gray-700 bg-gradient-to-b from-gray-800/80 to-gray-900/80 p-8 transition-all duration-300 hover:border-brand-primary hover:-translate-y-1 hover:shadow-2xl hover:shadow-brand-primary/10"
    >
      <svg
        class="pointer-events-none absolute -top-2 -right-2 h-24 w-24 text-brand-primary/10"
        fill="currentColor"
        viewBox="0 0 32 32"
        aria-hidden="true"
      >
        <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
      </svg>

      <div class="mb-4 flex gap-1 text-yellow-400">
        <svg v-for="i in 5" :key="i" class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      </div>

      <blockquote class="relative mb-6 flex-1 text-base leading-relaxed text-gray-200">
        "{{ item.value }}"
      </blockquote>

      <figcaption class="flex items-center gap-4 border-t border-gray-700/60 pt-5">
        <img
          v-if="item.image"
          :src="item.image"
          :alt="item.author"
          class="h-11 w-11 flex-shrink-0 rounded-full object-cover ring-2 ring-brand-primary/40"
        />
        <div
          v-else
          class="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-brand-primary to-brand-secondary ring-2 ring-brand-primary/40"
        >
          <span class="text-sm font-bold text-white">{{ getInitials(item.author) }}</span>
        </div>
        <div class="min-w-0">
          <p class="truncate font-semibold text-white">{{ item.author }}</p>
          <p class="truncate text-sm text-gray-400">
            {{ item.role }}<span v-if="item.company"> · {{ item.company }}</span>
          </p>
        </div>
      </figcaption>
    </figure>
  </div>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    required: true,
    validator: (items) =>
      items.every((i) => i.value && i.author),
  },
});

function getInitials(name) {
  if (!name) {
    return '?';
  }
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
</script>
